import DeleteIcon from '@mui/icons-material/Delete';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/icons-material/Delete": DeleteIcon, "@mui/material/Button": Button, "@mui/material/IconButton": IconButton, "@mui/material/Tooltip": Tooltip } } });
export default ClientProvider;
